import copy from 'clipboard-copy';
import { trackEvent } from '../../support-and-tracking/analytics-actions';
import { canUseNativeShare } from '../project-selectors';

export const filesArrayFromImage = async (urlToImageToShare) => {
    const imageResponse = await fetch(urlToImageToShare);
    const blob = await imageResponse.blob();
    const contentType = imageResponse.headers?.get('content-type');
    const fileType = contentType.split('/')[1];
    return [
        new File([blob], `bilde.${fileType}`, {
            type: contentType,
            lastModified: new Date().getTime(),
        }),
    ];
};

export const webShare = async ({ urlToShare, titleToShare, urlToImageToShare }) => {
    const files = urlToImageToShare ? await filesArrayFromImage(urlToImageToShare) : [];
    const shareData = {
        url: urlToShare,
        title: titleToShare,
        files: files,
    };

    if (navigator.canShare(shareData)) {
        try {
            await navigator.share(shareData);
        } catch (err) {
            // This is the error we get if we don't have permission to share
            // i.e. the transient activation has expired
            if (err.toString().includes('NotAllowedError')) {
            } else if (err.toString().includes('AbortError')) {
                // This is the error we get if the user cancels the share
                // i.e. the user clicks the back button
                trackEvent('support', 'cancel-native-share');
            } else {
                throw err;
            }
        }
    } else {
        throw Error('canShare = false og ingen fallback');
    }
};

export const nativeShareAction = async ({
    prettyUrl,
    projectTitle,
    trackingCategory,
    trackingAction,
    trackingProperties,
    copyLinkCallback,
}) => {
    const useNativeShare = canUseNativeShare();
    const shareData = {
        url: prettyUrl,
        title: projectTitle,
        text: projectTitle,
    };
    trackEvent(trackingCategory, trackingAction, {
        channel: 'link',
        ...trackingProperties,
    });

    if (useNativeShare && navigator.canShare(shareData)) {
        try {
            await navigator.share(shareData);
        } catch (err) {
            trackEvent('support', 'cancel-native-share');
            if (err.name !== 'AbortError') {
                throw err;
            }
        }
    } else {
        copy(prettyUrl);
        copyLinkCallback();
    }
};
